import React, { useEffect, useState } from "react";
import {
  TextField,
  Grid,
  Button,
  Avatar,
  Box,
  Typography,
  Card,
  CardContent
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person"; 
import Swal from "sweetalert2";
import { useAuth } from "../context/AuthContext";
import { updatePerfil } from "../services/usuarioService";

const ProfileForm = () => {
  const { user, updateUser } = useAuth();

  const [formData, setFormData] = useState({
    PrimerNombre: "",
    PrimerApellido: "",
    Correo: "",
    Celular: "",
    FotoPerfil: ""
  });

  const [preview, setPreview] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      setFormData({
        PrimerNombre: user.PrimerNombre || user.Nombre || "",
        PrimerApellido: user.PrimerApellido || user.Apellido || "",
        Correo: user.Correo || "",
        Celular: user.Celular || "",
        FotoPerfil: user.FotoPerfil || ""
      });
      if (user.FotoPerfil) {
        const isBase64 = user.FotoPerfil.startsWith("data:image");
        setPreview(isBase64 ? user.FotoPerfil : `data:image/jpeg;base64,${user.FotoPerfil}`);
      }
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prev) => ({
          ...prev,
          FotoPerfil: reader.result
        }));
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSave = async () => {
    if (!formData.PrimerNombre || !formData.PrimerApellido || !formData.Correo) {
      return Swal.fire("Error", "Por favor completa todos los campos obligatorios", "error");
    }
  
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.Correo);
    if (!isEmailValid) {
      return Swal.fire("Error", "Correo electrónico no válido", "error");
    }
  
    const updatedUser = {
      PrimerNombre: formData.PrimerNombre,
      PrimerApellido: formData.PrimerApellido,
      Correo: formData.Correo,
      Celular: formData.Celular,
      FotoPerfil: formData.FotoPerfil
    };
  
    try {
      setLoading(true);
  
      const userId = user?.idUsuario || user?.id;
      if (!userId) {
        throw new Error("No se encontró el id del usuario autenticado");
      }

      const response = await updatePerfil(userId, updatedUser);
  
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Perfil actualizado",
          text: "Los cambios se guardaron correctamente."
        });
  
        updateUser({
          ...user,
          PrimerNombre: formData.PrimerNombre,
          PrimerApellido: formData.PrimerApellido,
          Correo: formData.Correo,
          Celular: formData.Celular,
          FotoPerfil: formData.FotoPerfil
        });
      } else {
        Swal.fire("Error", response.message || "Error al actualizar el perfil", "error");
      }
    } catch (error) {
      console.error("Error al guardar perfil:", error);
      const serverMessage = error?.response?.data?.message || error?.response?.data?.messages?.error;
      Swal.fire(
        "Error",
        serverMessage || error?.message || "Error en la conexión con el servidor",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card sx={{ backgroundColor: "#fff", borderRadius: 2, boxShadow: "none" }}>
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          <PersonIcon color="primary" sx={{ mr: 1 }} /> {/* <-- Icono de persona */}
          <Typography variant="h6">Editar Perfil</Typography>
        </Box>

        <Box display="flex" alignItems="center" mb={3}>
          <Avatar
            src={preview}
            sx={{
              width: 100,
              height: 100,
              mr: 2,
              border: "2px solid #ddd",
              boxShadow: 1
            }}
          />
          <Box>
            <input
              accept="image/*"
              id="upload-photo"
              type="file"
              style={{ display: "none" }}
              onChange={handleImageChange}
            />
            <label htmlFor="upload-photo">
              <Button variant="outlined" component="span">
                Cambiar foto de perfil
              </Button>
            </label>
          </Box>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Nombre"
              name="PrimerNombre"
              value={formData.PrimerNombre}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Apellido"
              name="PrimerApellido"
              value={formData.PrimerApellido}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Correo Electrónico"
              name="Correo"
              value={formData.Correo}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Celular"
              name="Celular"
              value={formData.Celular}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        <Box mt={3} textAlign="right">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? "Guardando..." : "Guardar cambios"}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ProfileForm;
